import { useAuth } from "@vellum/micro-app-auth";
import { ErrorState, PageContainer } from "@vellum/ui";
import { UserRoles } from "@vellum/vellum-api";
import { Outlet } from "react-router-dom";

import { getHubUrl } from "@/config";

// Mirrors REPORTING_ROLES in vellum-api's dependencies.py, which is what
// actually enforces this; the check here only spares everyone else a page of
// failed requests.
const REPORTING_ROLES: UserRoles[] = [UserRoles.ADMIN, UserRoles.REGION_ADMIN];

/** Lets admins and region admins through; everyone else gets a dead end. */
export function RequireReportingRole() {
  const { user } = useAuth();

  if (user?.role && REPORTING_ROLES.includes(user.role)) {
    return <Outlet />;
  }

  return (
    <PageContainer>
      <ErrorState
        title="Reporting is limited to admins"
        message="Only admins and region admins can view reports. If you need access, ask an admin to update your role."
        actions={
          <a
            href={getHubUrl()}
            className="text-sm font-medium text-blue-500 no-underline hover:underline"
          >
            Back to Hub
          </a>
        }
      />
    </PageContainer>
  );
}
